const twoFactorAuth = {
  verifyIdentity: "Let's verify your identity",
  enterOtpMessage: "Enter the 6-digit code sent to your email.",
  verifyCode: "Verification code",
  codeExpiry: "The code will expire in 5 minutes.",
  sendNewEmail: "Resend verification email.",
};

export default twoFactorAuth;
